// extracted by mini-css-extract-plugin
export default {"skeletons":"RecommendedGames_skeletons__NEZtu","skeletonsItems":"RecommendedGames_skeletonsItems__lSe4l","skeletonsItem":"RecommendedGames_skeletonsItem__jJTzX"};